import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loadingStore: BehaviorSubject<boolean>

  isLoading$: Observable<boolean>

  constructor() {
    this.loadingStore = new BehaviorSubject<boolean>(false)
    this.isLoading$ = this.loadingStore.asObservable()
  }

  setLoading(isLoading: boolean): void {
    setTimeout(() => this.loadingStore.next(isLoading), 0)
  }
}
